import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import useTranslations from '~/components/translation/use-translations.ts';
import { authenticationSelector } from '~/components/authentication/ducks/selectors.js';
import { updateCredentials } from '~/components/authentication/ducks/index.js';
import BinaryQuestion from '~/components/binary-question';
import { hideBinaryNotification } from '~/components/notifications/ducks/notifications.js';
import { showSupportDialogBox } from '~/components/support/ducks/index.js';

const textKeys = [
	'TEMPORARY_ACCOUNT_ENDED',
	'TEMPORARY_ACCOUNT_ENDED_SUBTITLE',
	'BUTTON_CUSTOMER_SUPPORT',
	'TEMPORARY_ACCOUNT_ENDED_CONTINUE'
];

export default function TempAccLogout() {
	const [shouldOpenBinary, setShouldOpenBinary] = useState(false);
	const authenticated = useSelector(authenticationSelector);
	const isTemporaryExpired = useSelector(state => state.authentication?.isTemporaryExpired);
	const { translations: t } = useTranslations(textKeys);
	const dispatch = useDispatch();

	useEffect(() => {
		if (!authenticated && isTemporaryExpired) {
			// show binary notification here
			setShouldOpenBinary(true);
		}
	}, [authenticated, isTemporaryExpired]);

	return (
		<BinaryQuestion
			shouldOpenBinary={shouldOpenBinary}
			title={t.TEMPORARY_ACCOUNT_ENDED}
			text={t.TEMPORARY_ACCOUNT_ENDED_SUBTITLE}
			yesText={t.BUTTON_CUSTOMER_SUPPORT}
			onYesClick={() => {
				dispatch(showSupportDialogBox(true));
				dispatch(hideBinaryNotification());
				setShouldOpenBinary(false);
				dispatch(updateCredentials({ isTemporaryExpired: false }));
			}}
			noText={t.TEMPORARY_ACCOUNT_ENDED_CONTINUE}
			onNoClick={() => {
				dispatch(hideBinaryNotification());
				setShouldOpenBinary(false);
				dispatch(updateCredentials({ isTemporaryExpired: false }));
			}}
		/>
	);
}
